import { useEffect, useState, type ReactElement } from 'react';
import { SPACES } from '../../data/landing-mock';

export function SpacesGallery(): ReactElement {
  const [updated, setUpdated] = useState(2);

  useEffect(() => {
    const iv = setInterval(() => setUpdated((u) => (u < 15 ? u + 1 : 2)), 2000);
    return () => clearInterval(iv);
  }, []);

  return (
    <section className="landing-spaces-section" id="spaces">
      <div className="landing-section-head">
        <div className="landing-section-eyebrow">
          <span className="landing-brk">[</span> 03 · SPACES <span className="landing-brk">]</span>
        </div>
        <h2 className="landing-section-title">
          Eight worlds. <span className="landing-glow-cyan">Live right now.</span>
        </h2>
        <p className="landing-section-sub">
          Every Space is one Unreal Engine instance, bound to the cloud by a
          6-digit invite code. Browse the catalog, claim a Character, or spin up
          your own from the editor.
        </p>
      </div>

      <div className="landing-spaces-grid">
        {SPACES.map((sp) => (
          <div
            key={sp.id}
            className={`landing-space-card ${sp.tag} ${sp.feature ? 'feature' : ''} ${sp.wide ? 'wide' : ''}`}
          >
            <img src={sp.img} alt={sp.name} loading="lazy" className="landing-space-img" />
            <div className="landing-space-info">
              <h3 className="landing-space-title">{sp.name}</h3>
              <p className="landing-space-desc">{sp.desc}</p>
              <div className="landing-space-tags">
                <span className="landing-space-tag">{sp.ue}</span>
                <span className="landing-space-tag">{sp.region}</span>
                <span className="landing-space-tag">{sp.actors} actors</span>
                <span className="landing-space-tag">{sp.agents} agents</span>
              </div>
              <div className="landing-space-foot-row">
                <span className="landing-dot live" />
                <span className="landing-mono">{sp.intents_24h.toLocaleString()} intents / 24h</span>
                <span className="landing-space-code">{sp.id}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="landing-spaces-foot">
        <a href="#" className="landing-btn-outline">Browse full catalog →</a>
        <div className="landing-spaces-note landing-mono">
          <span className="landing-dot live" /> 8 of 847 Spaces shown · updated {updated}s ago
        </div>
      </div>
    </section>
  );
}
